const actions = {
    READ_USER_REQUEST: 'READ_USER_REQUEST',
    READ_USER_SUCCESS: 'READ_USER_SUCCESS',
    READ_USER_ERROR: 'READ_USER_ERROR',
    UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_ERROR: 'UPDATE_USER_ERROR',
    UPDATE_USER_PASSWORD_REQUEST: 'UPDATE_USER_PASSWORD_REQUEST',
    UPDATE_USER_PASSWORD_SUCCESS: 'UPDATE_USER_PASSWORD_SUCCESS',
    UPDATE_USER_PASSWORD_ERROR: 'UPDATE_USER_PASSWORD_ERROR',
    UPDATE_USER_LOCALE_REQUEST: 'UPDATE_USER_LOCALE_REQUEST',
    UPDATE_USER_LOCALE_SUCCESS: 'UPDATE_USER_LOCALE_SUCCESS',
    UPDATE_USER_LOCALE_ERROR: 'UPDATE_USER_LOCALE_ERROR',

    readUser: () => ({
        type: actions.READ_USER_REQUEST,
    }),
    updateUser: request => ({ // Current user
        type: actions.UPDATE_USER_REQUEST,
        request,
    }),
    updateUserPassword: request => ({
        type: actions.UPDATE_USER_PASSWORD_REQUEST,
        request,
    }),
    updateUserLocale: request => ({
        type: actions.UPDATE_USER_LOCALE_REQUEST,
        request,
    }),

};
export default actions;
